import React, {useEffect, useState, useCallback} from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter, Input, Spinner } from 'reactstrap'

/**
 * Modal for saving a custom shape to the server.
 * Collects shape name (required).
 *
 * @param {{
 * initialData?: {
 *   name?: string,
 *   previewUrl?: string,
 * }
 *   isOpen: boolean,
 *   onClose: () => void,
 *   onSuccess: (name: string) => Promise<void>
 *   onError?: (err: Error) => void
 * }} props
 */
function SaveShapeModal({initialData, isOpen, onClose, onSuccess, onError}) {
    const [name, setName] = useState(() => {
        return initialData?.name ?? ''
    })
    const [saving, setSaving] = useState(false)
    const [error, setError] = useState(null)

    const handleConfirm = useCallback(async () => {
        const trimmedName = name.trim()
        if (!trimmedName) return

        setSaving(true)
        setError(null)

        try {
            await onSuccess(trimmedName)
            setName('')
        } catch (err) {
            setError(err?.message || 'Failed to save shape. Please try again.')
            onError?.(err)
        } finally {
            setSaving(false)
        }
    }, [name, onSuccess, onError])

    const handleClose = useCallback(() => {
        if (saving) return
        setError(null)
        onClose()
    }, [saving, onClose])

    const handleInputChange = useCallback((e) => {
        console.log('input changed', e.target.value)

        setName(e.target.value)
    }, [])

    const canConfirm = name?.trim().length > 0 && !saving

    return (
        <Modal isOpen={isOpen} toggle={handleClose} className="SaveShapeModal">
            <ModalHeader toggle={handleClose}>Save shape</ModalHeader>
            <ModalBody>
                <div className="SaveShapeModal__Preview">
                    {initialData?.previewUrl && <img src={initialData.previewUrl} alt="Shape preview" />}
                </div>
                <div className="SaveShapeModal__Form">
                    <div className="SaveShapeModal__NameGroup">
                        <p className="SaveShapeModal__Label">Shape name</p>
                        <Input
                            id="save-shape-name"
                            type="text"
                            placeholder="Enter shape name"
                            value={name}
                            onChange={handleInputChange}
                            disabled={saving}
                            autoFocus
                        />
                    </div>
                    {/* <p className="SaveShapeModal__HelpText">
                        After you click <strong>Save</strong>, you'll be taken to the Print Design screen.
                    </p> */}
                    {error && (
                        <p className="SaveShapeModal__Error text-danger" role="alert">
                            {error}
                        </p>
                    )}
                </div>
            </ModalBody>
            <ModalFooter>
                <button
                    type="button"
                    className="CreateCustomShape__SecondaryButton"
                    onClick={handleClose}
                    disabled={saving}
                >
                    Cancel
                </button>
                <button
                    type="button"
                    className="CreateCustomShape__PrimaryButton"
                    onClick={handleConfirm}
                    disabled={!canConfirm}
                >
                    {saving ? (
                        <>
                            <Spinner size="sm" /> Saving…
                        </>
                    ) : (
                        'Save'
                    )}
                </button>
            </ModalFooter>
        </Modal>
    )
}

export default SaveShapeModal








